<template>
  <v-dialog v-model="dialog" scrollable width="800" @click:outside="close">
    <v-card style="min-height: 800px" :key="id">
      <iframe ref="approve-frame" id="approve-frame" :src="src" width="100%" height="100%" style="border: none" />
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { get } from 'lodash'
const IS_DEBUG = false
const PREFIX = IS_DEBUG ? 'http://localhost:8080' : 'https://lms-pdf-sign.netlify.app'
const VENDOR_ID = 'LTT'

export default {
  data: () => ({ dialog: false, src: PREFIX, id: '', ev: null }),
  computed: {
    ...mapGetters('auth', ['profile'])
  },

  methods: {
    ...mapActions('teacherDoc', ['updateTeacherDoc']),
    listen() {
      const $ = this
      this.ev = window.addEventListener(
        'message',
        e => {
          if (e.origin === PREFIX) {
            const url = get(e, 'data.url', '')
            if (typeof url === 'string' && url.length) $.save(url)
          }
        },
        false
      )
    },
    unlisten() {
      if (this.ev) {
        window.removeEventListener('message', this.ev)
      }
    },
    open(url, id) {
      this.id = id
      this.src = `${PREFIX}/?id=${id}&url=${url}&sign=${get(this.profile, 'metadata.signature')}&vendorId=${VENDOR_ID}`
      this.dialog = true
      this.$nextTick(() => {
        this.listen()
      })
    },
    close() {
      this.dialog = false
      this.reset()
      this.unlisten()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async save(url) {
      this.$loading.active = true
      try {
        await this.updateTeacherDoc({
          id: this.id,
          data: { status: 'approved', data: { signFile: url } }
        })
        this.$alert.success('Tài liệu đã được duyệt ký')
        this.$emit('onSave')
        this.close()
      } catch (error) {
        this.$alert.error('Lỗi duyệt tài liệu: ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
